import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Grid,
  Card,
  CardContent,
  CardActionArea,
  Typography,
  Box
} from '@mui/material';
import marketingService from '../services/marketingService';

export default function EmailTemplateSelector({ open, onClose, onSelect }) {
  const [templates, setTemplates] = useState([]);

  useEffect(() => {
    if (open) {
      loadTemplates();
    }
  }, [open]);

  const loadTemplates = async () => {
    try {
      const data = await marketingService.getTemplates();
      setTemplates(data.templates);
    } catch (error) {
      console.error('Failed to load templates:', error);
    }
  };

  const handleSelectTemplate = async (templateId) => {
    try {
      const template = await marketingService.getTemplate(templateId);
      onSelect(template);
    } catch (error) {
      console.error('Failed to load template:', error);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>Choose Email Template</DialogTitle>
      <DialogContent>
        <Grid container spacing={2} sx={{ mt: 1 }}>
          {templates.map((template) => (
            <Grid item xs={12} sm={6} key={template.id}>
              <Card>
                <CardActionArea onClick={() => handleSelectTemplate(template.id)}>
                  <CardContent>
                    <Typography variant="h6" gutterBottom>
                      {template.name}
                    </Typography>
                    <Typography variant="body2" color="text.secondary" gutterBottom>
                      {template.subject}
                    </Typography>
                    <Box
                      sx={{
                        mt: 2,
                        p: 1,
                        bgcolor: '#f5f5f5',
                        borderRadius: 1,
                        fontSize: '0.75rem',
                        color: 'text.secondary'
                      }}
                    >
                      {template.preview}
                    </Box>
                  </CardContent>
                </CardActionArea>
              </Card>
            </Grid>
          ))}
        </Grid>
      </DialogContent>
    </Dialog>
  );
}
